import React from 'react';
import type { ProjectType } from '@atlassian/jira-common-constants';

import { ProjectTypes } from '../../../common/constants/project';
import { IllustrationBoardView as IllustrationJSW } from './jsw';
import { Illustration as IllustrationJWM } from './jwm';
import messages from './messages';

type OldProps = {
	isTmp: boolean;
	projectName: string;
	projectKey: string;
};

export type Props = OldProps & {
	projectType: ProjectType | null;
};

export const Illustration = ({ projectType, ...props }: Props) => {
	switch (projectType) {
		case ProjectTypes.BUSINESS:
			return (
				<IllustrationJWM
					{...props}
					teamManagedIllustrationFooter={messages.teamManagedIllustrationFooter}
					companyManagedIllustrationFooter={messages.companyManagedIllustrationFooter}
				/>
			);
		case ProjectTypes.SOFTWARE:
			return (
				<IllustrationJSW
					{...props}
					teamManagedIllustrationFooter={messages.teamManagedIllustrationFooter}
					companyManagedIllustrationFooter={messages.companyManagedIllustrationFooter}
				/>
			);
		default:
			return null;
	}
};
